import classNames from 'classnames';
import React, {useCallback, useEffect, useRef, useState} from 'react';
import './styles.css';
import MediaQuery from 'react-responsive';
import QuestionIcon from '../icons/Question';
import InputLabel from '../InputLabel';

const SegmentedRadio = ({ checked, options, onChange, children, label, name, required, help, disabled }) => {
  const [selected, setSelected] = useState(checked);
  const firstFocus = useRef(true);
  const [tooltipActive, setTooltipActive] = useState(false);

  const handleChange = useCallback(option => {
    setSelected(option);
    onChange(option.value);
  }, [onChange]);

  const showTooltip = useCallback(() => {
      setTooltipActive(true);
  }, []);

  const hideTooltip = useCallback(() => {
    setTooltipActive(false);
  }, []);

  useEffect(() => {
    if (typeof checked !== 'undefined' && checked !== null) {
      const selected = options.find(option => option.value === checked);
      setSelected(selected);
    } else {
      setSelected(null);
    }
  }, [checked, options]);

  return (
    <div className={classNames('segmented-radio', {
      'segmented-radio--required': required,
      'segmented-radio--disabled': disabled,
      ['input--tooltip-active']: tooltipActive,
    })}>
      <InputLabel label={label} help={help}>
        <div
          className={'segmented-radio__wrapper'}
          onFocus={(e) => {
            if (firstFocus.current) {
              showTooltip();
            }

            firstFocus.current = false;
          }}
          onBlur={() => hideTooltip()}>
          <div className={'segmented-radio__options'}>
            {options.map(option => (
              <label
                key={option.value}
                className={`segmented-radio__option ${selected && selected.value === option.value ? 'segmented-radio__option--selected' : ''}`}
              >
                <input
                  type="radio"
                  disabled={disabled}
                  onChange={() => {
                    handleChange(option);
                  }}
                  name={name}
                  checked={!!selected && selected.value === option.value}
                  value={option.value}
                  required={required}
                />
                <span className="segmented-radio__option-label">
                  {option.label}
                </span>
              </label>
            ))}
          </div>
        </div>
      </InputLabel>
      {selected && !!selected.helpText && (
        <div className="segmented-radio__help-text">
          {selected.helpText}
        </div>
      )}
    </div>
  );
};

export default SegmentedRadio;
